// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"DivisionsPage_toolbar__1DNKw","add":"DivisionsPage_add__1g6_8","table":"DivisionsPage_table__3Bf44"};